module.exports = __webpack_public_path__ + "static/media/LS.7bbf0dc0.png";